export const CHUNK_SIZE = 16

export function processFilesChunked(files, onProgress, onComplete, onError) {
  const processedFiles = []
  let currentIndex = 0
  
  function processNextChunk() {
    const startTime = performance.now()
    
    while (currentIndex < files.length && (performance.now() - startTime) < CHUNK_SIZE) {
      const file = files[currentIndex]
      
      try {
        const url = URL.createObjectURL(file)
        
        const processedFile = {
          id: `${Date.now()}-${file.name}-${currentIndex}`,
          type: file.type.startsWith('image/') ? 'image' : 'video',
          source: 'upload',
          file,
          preview: url,
          url,
          size: file.size,
          name: file.name,
          lastModified: file.lastModified,
        }
        
        processedFiles.push(processedFile)
        
        if (onProgress) {
          onProgress({
            completed: currentIndex + 1,
            total: files.length,
            percentage: Math.round(((currentIndex + 1) / files.length) * 100),
            file: processedFile,
          })
        }
        
        currentIndex += 1
      } catch (error) {
        if (onError) {
          onError(`Error processing file ${file.name}: ${error.message}`, file.name)
        }
        currentIndex += 1
      }
    }
    
    if (currentIndex < files.length) {
      setTimeout(processNextChunk, 0)
    } else if (onComplete) {
        onComplete(processedFiles)
      }
  }
  
  if (files.length === 0) {
    if (onComplete) {
      onComplete([])
    }
    return
  }
  
  setTimeout(processNextChunk, 0)
}

export function processFilesDirect(files, onProgress, onComplete, onError) {
  const processedFiles = []
  
  try {
    files.forEach((file, index) => {
      const url = URL.createObjectURL(file)
      
      const processedFile = {
        id: `${Date.now()}-${file.name}-${index}`,
        type: file.type.startsWith('image/') ? 'image' : 'video',
        source: 'upload',
        file,
        preview: url,
        url,
        size: file.size,
        name: file.name,
        lastModified: file.lastModified,
      }
      
      processedFiles.push(processedFile)
      
      if (onProgress) {
        onProgress({
          completed: index + 1,
          total: files.length,
          percentage: Math.round(((index + 1) / files.length) * 100),
          file: processedFile,
        })
      }
    })
    
    if (onComplete) {
      onComplete(processedFiles)
    }
  } catch (error) {
    if (onError) {
      onError(`Error processing files: ${error.message}`)
    }
  }
}

export function detectProcessingCapabilities() {
  const hasWebWorkers = typeof Worker !== 'undefined'
  const hasRequestIdleCallback = typeof requestIdleCallback !== 'undefined'
  
  let preferredMethod
  if (hasWebWorkers) {
    preferredMethod = 'worker'
  } else if (hasRequestIdleCallback) {
    preferredMethod = 'chunked'
  } else {
    preferredMethod = 'direct'
  }

  return {
    webWorkers: hasWebWorkers,
    requestIdleCallback: hasRequestIdleCallback,
    preferredMethod,
  }
}
